import React from 'react';
import { Img } from 'react-image';
import styled, { ThemeContext } from 'styled-components';
import { SectionName, SectionTitle, BigButton } from '../common/styles';
import dt from '../../../shared/theme';

const Container = styled.div`
  border-radius: 0 ${props => (props.theme.isMobile ? 150 : 200)}px;
  background-image: linear-gradient(
    180deg,
    ${props => props.theme.bodyColor},
    ${props => props.theme.secondaryColor});
  display: flex;
  flex-direction: column;
  padding: 121px 172px 128px 172px;
  ${props => dt(props).theme.isXLarge && `
    flex-direction: row;
    justify-content: center;

    &:after {
      order: 0;
      content: "";
      width: 9vw;
      max-width: 130px;
    }
  `};
  
  ${props => (props.theme.isMobile && `
    align-items: center;
    padding: 60px 20px 100px 20px;
  `)};
`;

const TextContainer = styled.div`
  order: -1;
  display: flex;
  flex-direction: column;
  align-items: start;
  width: ${props => (dt(props).theme.isXLarge ? '31.25vw' : '100%')};
  margin-bottom: 20px;
`;

const Name = styled(SectionName)`
  margin-bottom: 20px;
`;

const Title = styled(SectionTitle)`
  color: white;
  width: 100%;
  margin: 0;
  margin-bottom: 20px;
`;

const Desc = styled.p`
  width: 100%;
  margin: 0;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightMedium};
  font-size: 19px;
  line-height: 20px;
  color: white;
`;

const Button = styled(BigButton)`
  width: 172px;
  box-shadow: 0 3px 20px ${props => props.theme.secondaryColor30Transparent};
  ${props => (props.theme.isMobile ? `
    margin: 20px 0;
  ` : `
    margin-top: 45px;
  `)};
`;

const Image = styled(Img)`
  order: 1;
  border-radius: 4px;
  ${props => (props.theme.isMobile && `
    width: 90vw;
    height: 90vw;
  `)} 
  
  ${props => dt(props).theme.isXLarge && `
    width: 35.8vw;
    height: 32.2vw;
  `};
`;

function redirectToOurStory(e) {
  if (e) {
    e.preventDefault();
  }
  window.location = '/company/our_story';
}

export default function OurStory() {
  const { ourStory } = React.useContext(ThemeContext);

  return (
    <Container>
      <TextContainer>
        <Name>our story</Name>
        <Title>
          From a kitchen table to Australia’s fastest growing investment insights website
        </Title>
        <Desc>
          Livewire Markets started with the idea: Investing would be so much
          simpler if we could cut through this noise to one source that provides
          all the ideas, commentary and tips we need.
        </Desc>
        <Button onClick={redirectToOurStory}>learn more</Button>
      </TextContainer>
      <Image src={ourStory} />
    </Container>
  );
}
